/* eslint-disable react-hooks/rules-of-hooks */
import { useTranslation } from 'react-i18next';
import type { ColumnDef } from '@tanstack/react-table';

import type { ModelRunsQueryResult } from '@/api/generated';
import { ColumnHeader } from '@/components/blocks/data-table/column-header';
import { Preview } from '@/components/blocks/preview/preview';

type ModelRun = ModelRunsQueryResult['data'][number];

export const columns: Array<ColumnDef<ModelRun>> = [
  {
    accessorKey: 'input',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('overview.input')}
        />
      );
    },
    cell: ({ row }) => {
      const input = row.original.input;
      if (!input.path) {
        return null;
      }

      return (
        <Preview
          id={input.id}
          options={{
            mutationKey: `${input.id}`,
            path: input.path,
          }}
        />
      );
    },
  },
  {
    accessorKey: 'output',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('overview.output')}
        />
      );
    },
    cell: ({ row }) => {
      const output = row.original.output;
      if (!output?.path) {
        return null;
      }

      return (
        <Preview
          id={output.id}
          options={{
            mutationKey: `${output.id}`,
            path: output.path,
          }}
        />
      );
    },
  },
];
